/* eslint-disable react/jsx-pascal-case */
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as _Select,
} from '@mui/material'

const Select = ({ formData, handleChange, formControlProps, ...rest }) => {
  const { variant = 'outlined', hideLabel = false } = rest

  return (
    <FormControl sx={{ m: 1, margin: 0 }} variant={variant} {...formControlProps}>
      {!hideLabel && <InputLabel>{formData.label}</InputLabel>}
      <_Select
        {...formData}
        label={hideLabel ? undefined : formData.label}
        variant={variant}
        onChange={handleChange}
        {...rest}
      >
        {formData.options.map(({ value, name }) => (
          <MenuItem key={value} value={value}>
            {name}
          </MenuItem>
        ))}
      </_Select>
    </FormControl>
  )
}

export { Select }
